import { configureStore } from '@reduxjs/toolkit'
import modalSlice from "@/Store/Slices/ModalSlice";
import imageSlice from "@/Store/Slices/ImageSlice";


export default configureStore({
  reducer: {
    modal: modalSlice,
    image: imageSlice
  },
})
